import {Component, OnInit, ViewChild} from '@angular/core';
import {CompetitionService} from 'app/services/competition.service';
import {StadiumCamerasService} from 'app/services/stadium-cameras.service';
import {PannellumStadiumCamera} from 'app/models/pannellum-stadium-camera';
import {File} from 'app/models/file';
import {Stadium} from 'app/models/stadium';
import {Competition} from '../../models/competition';

@Component({
    selector: 'app-stadium-admin',
    templateUrl: './stadium-admin.component.html',
    styleUrls: ['./stadium-admin.component.scss']
})
export class StadiumAdminComponent implements OnInit {
    stadium: Stadium;
    competition: Competition;
    currentCamera: PannellumStadiumCamera;
    @ViewChild('stadium360') stadium360: any;

    constructor(private stadiumCamerasService: StadiumCamerasService, private competitionService: CompetitionService) {}

    getAll() {
        this.stadiumCamerasService.getAll()
            .subscribe(res => this.stadium = res);
    }

    update() {
        this.stadiumCamerasService.update(this.stadium)
            .subscribe(res => {
                this.stadium = res;
                // Force refresh on error, for some reason angular doesnt detect change in stadium when this happens
            }, err => this.stadium360.refreshPannellumHotSpots(),
        );
    }

    deleteCamera(id: string) {
        for (const k in this.stadium.pannellumStadiumCamera) {
            if (this.stadium.pannellumStadiumCamera[k].id === id) {
                // @ts-ignore
                this.stadium.pannellumStadiumCamera.splice(k, 1)
                this.update()
                break
            }
        }
    }

    editCamera($event: {type: string, description: string, posName: string, pitch: number, yaw: number}) {
        this.currentCamera.createTooltipArgs.type = $event.type;
        this.currentCamera.createTooltipArgs.description = $event.description;
        this.currentCamera.posName = $event.posName
        this.currentCamera.pitch = $event.pitch
        this.currentCamera.yaw = $event.yaw

        this.update();
    }

    attachDocument($event: File) {
        this.currentCamera.createTooltipArgs.files.push($event);
        this.update();
    }

    deleteDocument($event: File) {
        this.currentCamera.createTooltipArgs.files =
            this.currentCamera.createTooltipArgs.files.filter(res => ($event.id !== res.id));
        this.update();
    }

    ngOnInit() {
        this.getAll();
        this.competition = this.competitionService.getCompetitionSelected();
    }

    onSelectChange(event) {
      this.competitionService.update(this.competition).subscribe(r => {
        this.competition = r;
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/views/stadium-admin/stadium-admin.component.ts